export interface iCasesIcon {
    isActive?: boolean;
}

export const Cases = (props: iCasesIcon) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 21V8H21V21H3Z" fill={props.isActive ? "#1F1F1F" : "white"} stroke={props.isActive ? "#1F1F1F" : "#808080"} strokeWidth="2"/>
        <path d="M8 7V3H16V7" stroke={props.isActive ? "#1F1F1F" : "#808080"} strokeWidth="2"/>
        </svg>
    );
  };